(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/betslip/betslip.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/betslip/betslip.js');

'use strict';

const {
  useContext,
  useEffect,
  useState,
  useRef
} = React;
const Button = svs.ui.Button;
const ReactIcon = svs.ui.ReactIcon;
const {
  PlayerServiceContext
} = svs.components.racing.player_service_state;
const {
  Currency
} = svs.utils.format;
const {
  products
} = svs.utils;
const {
  marketplace
} = svs.components;
const {
  AccountSelectorContainer,
  CommissionSelector,
  useAccount,
  payGame
} = marketplace.accountSelector;
const {
  useNavigationActions
} = svs.racing.navigation;
const {
  AllOrders,
  AmountPicker
} = svs.racing_game.components.play;
const wager = svs.components.racing.wager;
const payableStatus = svs.racing.gameEngine.payableStatus;
const PlayContext = svs.racing_game.components.playContext.PlayContext;
const CouponContext = svs.racing_game.components.playContext.CouponContext;
const scrollToTop = () => {
  if (svs.core.detect.formfactor.mobile()) {
    document.querySelector('html, body').scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    document.querySelector('.left-column').scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
};
const Betslip = _ref => {
  let {
    isDisabled,
    disabledReason
  } = _ref;
  const {
    engine,
    race
  } = useContext(PlayContext);
  const {
    refreshWagers,
    selectedMode
  } = useContext(PlayerServiceContext);
  const ref = useRef();
  const {
    getPayableState,
    isAnyOrder,
    getMeta
  } = engine.selectors;
  const {
    marketplaceAccount,
    accountBalance,
    hasMarketplaceAccount
  } = useAccount(getMeta().drawNumber, products.productIds.RACING);
  const {
    toRaceWithRow
  } = useNavigationActions();
  const [isIntersecting, setIsIntersecting] = useState(false);
  const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService;
  const {
    setAnyOrder
  } = engine.actions;
  const anyOrderAvailable = engine.anyOrderAvailable && isAnyOrder;
  const showAllOrders = engine.anyOrderAvailable;
  const anyOrder = showAllOrders ? isAnyOrder() : false;
  const amounts = engine.stake.amounts;
  const gameType = engine.gameType;
  const useHasChanged = val => {
    const prevVal = usePrevious(val);
    return prevVal !== val;
  };
  const usePrevious = value => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };
  const logValidCoupon = () => {
    svs.components.analytics.trackEvent({
      category: 'Wager',
      action: 'Betslip Complete',
      opt_label: 'Hästar'
    });
  };
  const renderBetslipFooterTag = () => React.createElement("div", {
    className: "betslip-footer-tag fixed"
  }, marketplaceAccount.name);
  const renderBetslipAmount = payableState => {
    switch (payableState.status) {
      case payableStatus.INCOMPLETE:
        return React.createElement("div", {
          className: "betslip-top-right disabled".concat(isIntersecting ? ' scrolled-to-bottom' : '')
        }, "-- kr");
      case payableStatus.MAX_SELECTIONS:
        return React.createElement("div", {
          className: "betslip-top-right disabled".concat(isIntersecting ? ' scrolled-to-bottom' : '')
        }, "".concat(Currency(payableState.amount), " kr"));
      case payableStatus.INVALID_ROW_PRICE:
      case payableStatus.MIN_AMOUNT:
      case payableStatus.MAX_AMOUNT:
        return React.createElement("div", {
          className: "betslip-top-right error".concat(isIntersecting ? ' scrolled-to-bottom' : '')
        }, "".concat(Currency(payableState.amount), " kr"));
      case payableStatus.VALID:
      default:
        return React.createElement("div", {
          className: "betslip-top-right".concat(isIntersecting ? ' scrolled-to-bottom' : ''),
          id: "betslip-top-right"
        }, "".concat(Currency(payableState.amount), " kr"), React.createElement("div", null, React.createElement(ReactIcon, {
          color: "fc-white",
          icon: "menu-down",
          size: "100"
        })));
    }
  };
  const {
    selectedAmount,
    setSelectedAmount
  } = useContext(CouponContext);
  const payableState = getPayableState(selectedAmount);
  const hasError = payableState.status !== payableStatus.VALID && payableState.status !== payableStatus.INCOMPLETE;
  const showErrorBottom = hasError || isDisabled;
  const hasPayableStateChanged = useHasChanged(payableState.status);
  const scrollToBetslip = () => {
    if (svs.core.detect.formfactor.mobile()) {
      var _document;
      const scrollHeight = (_document = document) === null || _document === void 0 || (_document = _document.body) === null || _document === void 0 ? void 0 : _document.scrollHeight;
      document.querySelector('html, body').scrollTo({
        top: scrollHeight,
        behavior: 'smooth'
      });
    } else {
      const betslipWrapper = document.getElementsByClassName('betslip-racing-wrapper');
      const topPos = betslipWrapper[0].offsetTop;
      document.querySelector('.left-column').scrollTo({
        top: topPos,
        behavior: 'smooth'
      });
    }
    if (!isSelfService && document.getElementById('betslip-top-right')) {
      document.getElementById('betslip-top-right').classList.add('scrolled-to-bottom');
    }
  };
  useEffect(() => {
    if (hasPayableStateChanged && payableState.status === payableStatus.VALID) {
      logValidCoupon();
    }
  });
  useEffect(() => {
    if (!isSelfService) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(_ref2 => {
          let {
            intersectionRatio
          } = _ref2;
          const isIntersectingNow = intersectionRatio > 0.05;
          setIsIntersecting(isIntersectingNow);
        });
      });
      if (ref.current) {
        observer.disconnect();
        observer.observe(ref.current);
      }
      return () => {
        observer.disconnect();
      };
    }
  }, [isIntersecting, setIsIntersecting, ref, isSelfService]);

  const stickyEl = useRef();
  useEffect(() => {
    stickyEl.current.style.display = 'none';
    stickyEl.current.offsetHeight;
    stickyEl.current.style.display = '';
  }, [payableState.amount]);
  const payBtnTxt = isSelfService ? 'Lägg i Varukorg' : "Betala ".concat(Currency(payableState.amount), " kr");
  const payWager = () => wager.createWager(engine, payableState.amount, selectedAmount, getMeta().drawNumber, race, () => {
    setSelectedAmount(amounts[engine.stake.amountsDefaultIndex]);
    const searchParams = new URLSearchParams(window.location.search);
    if (selectedMode === 'active' && searchParams.get('flik') === 'mina-spel') {
      setTimeout(() => {
        refreshWagers();
      }, 1000);
    }
    scrollToTop();
  }, toRaceWithRow, {
    marketplace,
    isRetailerAdmin: svs.racing_game.data.isRetailerAdmin
  });
  const onPayClickHandler = () => payGame({
    marketplaceAccount,
    drawNumber: getMeta().drawNumber,
    productId: products.productIds.RACING
  }, payWager);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "betslip-top-wrapper fixed",
    id: "betslipTop",
    onClick: () => scrollToBetslip(),
    ref: stickyEl
  }, React.createElement("div", {
    className: "betslip-top"
  }, React.createElement("div", {
    className: "betslip-top-left",
    key: payableState.statusText
  }, React.createElement("div", {
    className: "betslip-top-left-item"
  }, payableState.statusText), React.createElement("div", {
    className: "betslip-top-left-item"
  }, React.createElement("span", {
    className: "betslip-number-of-rows-info"
  }, payableState.summaryText))), marketplaceAccount && renderBetslipFooterTag(), renderBetslipAmount(payableState))), React.createElement("div", {
    className: "betslip-racing-wrapper",
    id: "betslipWrapper"
  }, payableState && payableState.type, anyOrderAvailable && React.createElement(AllOrders, {
    isAnyOrder: anyOrder,
    setAnyOrder: setAnyOrder
  }), React.createElement(AmountPicker, {
    amountDisabled: payableState.amountDisabled,
    amounts: amounts,
    gameType: gameType,
    isFreeAmountAvailable: engine.stake.freeAmountAvailable,
    maxStake: engine.stake.max,
    minInputRowPrice: engine.stake.minInputRowPrice,
    selectedAmount: selectedAmount,
    setSelectedAmount: amount => {
      setSelectedAmount(amount);
    }
  }), hasMarketplaceAccount && React.createElement("div", {
    className: "account-selector-holder"
  }, svs.racing_game.data.isRetailerAdmin && React.createElement(CommissionSelector, {
    className: "padding"
  }), React.createElement(AccountSelectorContainer, null)), React.createElement("div", {
    className: "betslip-bottom",
    id: "betslipBottom",
    ref: ref
  }, Boolean(accountBalance) && marketplaceAccount && React.createElement("div", {
    className: "f-center margin-xs-bottom-1"
  }, "Saldo: ".concat(Currency(accountBalance), " kr")), React.createElement(Button, {
    block: true,
    className: "racing-betslip-pay-button",
    disabled: payableState.status !== payableStatus.VALID || isDisabled,
    focus: true,
    onClick: onPayClickHandler
  }, payBtnTxt), showErrorBottom && React.createElement("div", {
    className: "error"
  }, React.createElement(ReactIcon, {
    color: "fc-red",
    icon: "exclamation-sign",
    size: "300"
  }), React.createElement("div", null, isDisabled ? disabledReason : payableState.statusText)))));
};
Betslip.defaultProps = {
  disabledReason: 'Loppet är tillfälligt stängt'
};
svs.racing_game.components.play.Betslip = Betslip;

 })(window);